import React from "react";
import clsx from "clsx";

import { ReactComponent as ArrowLeftUp } from "../../assets/icons/arrow_left_up.svg";
import RealizationContentHeader from "../RealizationContentHeader";
import { IReflectionRealization } from "../../state";

import styles from "./ReflectionRealization.module.scss";

type Props = {
  realization: IReflectionRealization;
  isDetail?: boolean;
  showAuthor?: boolean;
};

const ReflectionRealization = ({
  realization,
  isDetail,
  showAuthor,
}: Props) => {
  return (
    <div className={styles.rootWrapper}>
      <ArrowLeftUp className={styles.icon} />
      <div className={styles.content}>
        {!realization.deleted && (
          <RealizationContentHeader
            realization={realization}
            isReflection
            showAuthor={showAuthor}
          />
        )}
        <p
          className={clsx(
            styles.text,
            isDetail ? styles.detail : styles.listItem,
            realization.deleted && styles.deleted,
          )}
        >
          {realization.content}
        </p>
      </div>
    </div>
  );
};

export default ReflectionRealization;
